import type { FirehoseMessageDeps } from './firehose-message-deps.js';

/** Firehose sends proxy id as first 36 bytes (UUID) of binary frames carrying request body. */
const PROXY_ID_BYTES = 36;
const PROXY_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * If this buffer is a trailing body for a streaming proxy (or arrives before metadata), consume it.
 */
export function tryConsumeBinaryProxyBody(raw: Buffer, deps: FirehoseMessageDeps): boolean {
  if (raw.length < PROXY_ID_BYTES) return false;
  const id = raw.slice(0, PROXY_ID_BYTES).toString('utf8');
  if (!PROXY_ID_RE.test(id)) return false;
  const body = raw.slice(PROXY_ID_BYTES);
  const bodyBytes = body.length > 0 ? new Uint8Array(body) : new Uint8Array(0);

  const pending = deps.pendingProxyBody.get(id);
  if (pending) {
    deps.pendingProxyBody.delete(id);
    deps.startStreamingProxy({
      ...pending.pr,
      body: bodyBytes.length > 0 ? bodyBytes : undefined,
    });
    return true;
  }

  // Metadata JSON has not been processed yet — buffer so it is not mis-parsed as JSON.
  deps.earlyProxyBinaryBody.set(id, bodyBytes);
  return true;
}
